import { useNavigate } from 'react-router-dom'

export default function Logo({ size = 'lg' }) {
  const navigate = useNavigate()
  const sizes = {
    sm: '1.25rem',   // 20px — tab bar / inline
    md: '1.75rem',   // 28px — headers
    lg: '2.75rem',   // 44px — auth screens
    xl: '4rem',      // 64px — hero
  }
  const fontSize = sizes[size] || sizes.lg

  return (
    <button
      onClick={() => navigate('/')}
      className="fp-wordmark bg-transparent border-none cursor-pointer p-0"
      style={{ fontSize, display: 'inline-block' }}
    >
      <span style={{ color: '#ffffff' }}>Flick</span>
      <span style={{ color: 'var(--fp-red)' }}>Pick</span>
    </button>
  )
}
